import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.194 2.77a3.31 3.31 0 0 0-4.902.243L6.909 9.591l-.044.059a3.97 3.97 0 0 0-3.524 1.22c-.436.442-.695 1.117-.866 1.743a14 14 0 0 0-.373 2.092 26 26 0 0 0-.152 2.535v.06a.747.747 0 0 0 .75.75h.06l.159-.002c.136-.003.331-.007.568-.017.474-.019 1.12-.057 1.808-.133.685-.076 1.43-.192 2.092-.373.626-.171 1.301-.43 1.744-.866a3.97 3.97 0 0 0 1.21-3.579l6.609-5.409a3.31 3.31 0 0 0 .244-4.902Zm-1.195 3.74-6.111 5.002q-.136-.164-.3-.348a8.6 8.6 0 0 0-1.14-1.087l5.005-6.114a1.81 1.81 0 1 1 2.546 2.547M5.13 16.407q-.27.03-.527.052l1.414-1.415a.75.75 0 0 0-1.06-1.06L3.54 15.397q.022-.258.052-.528c.072-.646.178-1.305.33-1.862.16-.588.34-.94.49-1.09a2.464 2.464 0 0 1 3.648-.022l.043.043a2.467 2.467 0 0 1-.022 3.648c-.15.15-.502.33-1.09.49-.557.152-1.216.258-1.862.33Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaint;
